import { supabase } from './supabase';
import {
  buildInventoryByCategory,
  monthRangeIso,
  type InventoryCategoryGroup,
} from './inventoryCategoryReport';

interface PurchasedTransactionRow {
  quantity: number;
  price: number;
  stock_items: {
    id: string;
    name: string;
    unit: string;
    category_id: string | null;
    category: { id: string; name: string } | null;
  };
}

/** Stock received this month grouped by category (purchase cost at receive). */
export async function fetchInventoryPurchasedByCategory(
  businessId: string
): Promise<InventoryCategoryGroup[]> {
  if (!supabase) throw new Error('Database connection not available');

  const { start, end } = monthRangeIso();
  const { data, error } = await supabase
    .from('stock_transactions')
    .select(
      `
      quantity,
      price,
      stock_items!inner(
        id,
        name,
        unit,
        category_id,
        business_id,
        category:stock_categories(
          id,
          name
        )
      )
    `
    )
    .eq('type', 'purchase')
    .eq('stock_items.business_id', businessId)
    .gte('created_at', start)
    .lte('created_at', end);

  if (error) throw error;

  const entries = ((data ?? []) as PurchasedTransactionRow[]).flatMap((row) => {
    const item = row.stock_items;
    if (!item) return [];

    const qty = Math.abs(Number(row.quantity) || 0);
    if (qty <= 0) return [];

    return [
      {
        itemId: item.id,
        name: item.name,
        unit: item.unit,
        quantity: qty,
        amount: qty * (Number(row.price) || 0),
        categoryId: item.category_id,
        categoryName: item.category?.name ?? 'Uncategorized',
      },
    ];
  });

  return buildInventoryByCategory(entries);
}

export type { InventoryCategoryGroup };
